import { render, staticRenderFns } from "./pad.vue?vue&type=template&id=4564ee54&scoped=true"
import script from "./pad.vue?vue&type=script&lang=js"
export * from "./pad.vue?vue&type=script&lang=js"
import style0 from "./pad.vue?vue&type=style&index=0&id=4564ee54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4564ee54",
  null
  
)

export default component.exports